import {
  NOTIFICACAO_PUSH_LOAD_CLIENTS,
  NOTIFICACAO_PUSH_SEND,
  NOTIFICACAO_PUSH_GET_ENVIO,
  NOTIFICACAO_PUSH_AGENDAR,
  NOTIFICACAO_PUSH_GET_AGENDAMENTO,
  NOTIFICACAO_PUSH_ATUALIZAR_AGENDAMENTO,
  NOTIFICACAO_PUSH_CANCELAR_AGENDAMENTO
} from "../actions/notificacaoPush";
import { ERRORS_SHOW } from "../actions/errors";
import Api from "../../service/api-web";

const state = {};

// erros de validacao (400) e de regra (409) sao exibidos pela propria tela
export const extrairErroAgendamento = err => {
  const data = (err && err.response && err.response.data) || {};
  return {
    status: err && err.response ? err.response.status : null,
    mensagem: data.error || "Falha ao processar o agendamento.",
    campos: data.campos || {}
  };
};

const getters = {};

const actions = {
  [NOTIFICACAO_PUSH_LOAD_CLIENTS]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v2.marketing.push
        .getUsers(
          getters.getFornecedorId,
          payload.cadastroStart,
          payload.cadastroEnd,
          payload.compraStart,
          payload.compraEnd,
          payload.acessoStart,
          payload.acessoEnd,
          payload.nascimentoStart,
          payload.nascimentoEnd,
          payload.carrinhoAberto,
          payload.cadastroAprovado,
          payload.segmentosSelecionados,
          payload.fornecedoresSelecionados,
          payload.atendentesPadrao,
          payload.offset,
          payload.limit,
          payload.canal
        )
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [NOTIFICACAO_PUSH_SEND]: ({ dispatch, getters }, payload) => {
    const data = {
      ...payload,
      idfornecedor: getters.getFornecedorId
    };
    return new Promise((resolve, reject) => {
      Api.v2.marketing.push
        .notificar(data)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [NOTIFICACAO_PUSH_GET_ENVIO]: (
    { dispatch, getters },
    { id, refreshMetrics }
  ) => {
    return new Promise((resolve, reject) => {
      Api.v2.marketing.push
        .getEnvio(id, getters.getFornecedorId, refreshMetrics)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [NOTIFICACAO_PUSH_AGENDAR]: ({ getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v2.marketing.push
        .agendar(getters.getFornecedorId, payload)
        .then(resp => resolve(resp.data))
        .catch(err => reject(extrairErroAgendamento(err)));
    });
  },
  [NOTIFICACAO_PUSH_GET_AGENDAMENTO]: ({ dispatch, getters }, id) => {
    return new Promise((resolve, reject) => {
      Api.v2.marketing.push
        .getAgendamento(id, getters.getFornecedorId)
        .then(resp => resolve(resp.data))
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [NOTIFICACAO_PUSH_ATUALIZAR_AGENDAMENTO]: ({ getters }, { id, payload }) => {
    return new Promise((resolve, reject) => {
      Api.v2.marketing.push
        .atualizarAgendamento(id, getters.getFornecedorId, payload)
        .then(resp => resolve(resp.data))
        .catch(err => reject(extrairErroAgendamento(err)));
    });
  },
  [NOTIFICACAO_PUSH_CANCELAR_AGENDAMENTO]: ({ getters }, id) => {
    return new Promise((resolve, reject) => {
      Api.v2.marketing.push
        .cancelarAgendamento(id, getters.getFornecedorId)
        .then(resp => resolve(resp.data))
        .catch(err => reject(extrairErroAgendamento(err)));
    });
  }
};
const mutations = {};
export default {
  state,
  getters,
  actions,
  mutations
};
